angular.module( 'acme.view.application.roles.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.roles.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var rolesList = {
        name: 'application.roles.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'RolesListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/roles/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Manage Roles',
          permissions: ['ROLES_VIEW']
        }
      };

    $stateProvider
      .state(rolesList);
});
